import { BaseReducer } from '@hobs/utils/baseReducer';
import {
  GETANNEXOVERVIEW,
  GETAUDITLOGGRID,
  GETEXERCISEGRID,
  GETPARTYGRID,
  GETREQUESTEDSERVICES,
  GETSORGRID,
  GETUSERGRID,
  GET_CATALOG_GRID,
  GET_ORDER_GRID,
  GET_GROUP_GRID,
  GET_TICKET_GRID
} from '@hobs/constants/gridSelections';

class GridSelection extends BaseReducer {
  static defaultState = {
    annexOverviewGrid: {},
    auditLogGrid: {},
    exerciseGrid: {},
    partyGrid: {},
    requestedServicesGrid: {
      statuses: [],
      groups: [],
      annexes: [],
      unitsOfMeasure: [],
      regions: []
    },
    catalogGrid: {},
    sorGrid: {},
    userGrid: {},
    orderGrid: {},
    groupGrid: {
      annexes: []
    },
    ticketGrid: {
      additionalRequestsStatuses: [],
      additionalRequestTypes: [],
      assigned: [],
      sendingNations: []
    }
  };

  constructor() {
    super(GridSelection.defaultState);
    this.actionMap = {
      [GETANNEXOVERVIEW.SUCCESS]: this.loadAnnexOverviewGrid,
      [GETAUDITLOGGRID.SUCCESS]: this.loadAuditLogGrid,
      [GETEXERCISEGRID.SUCCESS]: this.loadExerciseGrid,
      [GETPARTYGRID.SUCCESS]: this.loadPartyGrid,
      [GETREQUESTEDSERVICES.SUCCESS]: this.loadRequestedServicesGrid,
      [GETSORGRID.SUCCESS]: this.loadSorGrid,
      [GETUSERGRID.SUCCESS]: this.loadUserGrid,
      [GET_CATALOG_GRID.SUCCESS]: this.loadCatalogGrid,
      [GET_ORDER_GRID.SUCCESS]: this.loadOrderGrid,
      [GET_GROUP_GRID.SUCCESS]: this.loadGroupGrid,
      [GET_TICKET_GRID.SUCCESS]: this.loadTicketGrid
    };
  }

  loadAnnexOverviewGrid = (state, action) => {
    return Object.assign({}, state, {
      annexOverviewGrid: action.response
    });
  };

  loadAuditLogGrid = (state, action) => {
    return Object.assign({}, state, {
      auditLogGrid: action.response
    });
  };

  loadExerciseGrid = (state, action) => {
    return Object.assign({}, state, {
      exerciseGrid: action.response
    });
  };

  loadPartyGrid = (state, action) => {
    return Object.assign({}, state, {
      partyGrid: action.response
    });
  };

  loadRequestedServicesGrid = (state, action) => {
    return Object.assign({}, state, {
      requestedServicesGrid: action.response
    });
  };

  loadSorGrid = (state, action) => {
    return Object.assign({}, state, {
      sorGrid: action.response
    });
  };

  loadUserGrid = (state, action) => {
    return Object.assign({}, state, {
      userGrid: action.response
    });
  };
  loadCatalogGrid = (state, action) => {
    return Object.assign({}, state, {
      catalogGrid: action.response
    });
  };
  loadOrderGrid = (state, action) => {
    return Object.assign({}, state, {
      orderGrid: action.response
    });
  };
  loadGroupGrid = (state, action) => {
    return Object.assign({}, state, {
      groupGrid: action.response
    });
  };
  loadTicketGrid = (state, action) => {
    return Object.assign({}, state, {
      ticketGrid: action.response
    });
  };
}
export default new GridSelection().reducer;
